import './style.scss';

export const Error500 = ({ title, status, message }) => (
  <section className="py-12 d-flex flex-column align-items-center">
    <div className="container-fluid">
      <div>
        <h1 className="mb-none">{title || 'Something Went Wrong'}</h1>
        <div className="error-number lh-1 mb-4">{status || '500'}</div>
      </div>
      {message || (
      <p>
        Oops! The server encountered an internal error or misconfiguration and was unable to complete your request.
      </p>
      )}
    </div>
  </section>
);

export default Error500;
